export const environment = {
  production: true,
  buildId: '2688874988818431',
  configFile: 'config.json',
};
